// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

// const exportToPDF = (data, title, columns, rows) => {
//   const doc = new jsPDF();

//   // Add title
//   doc.setFontSize(18);
//   doc.text(title, 14, 22);

//   // Add date
//   doc.setFontSize(12);
//   doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

//   // Add table
//   autoTable(doc, {
//     head: [columns],
//     body: rows,
//     startY: 40,
//     theme: 'grid',
//     headStyles: {
//       fillColor: [59, 130, 246], // bg-primary-500
//       textColor: 255
//     },
//     styles: {
//       font: 'helvetica',
//       fontSize: 10
//     },
//     alternateRowStyles: {
//       fillColor: [243, 244, 246] // bg-neutral-100
//     }
//   });

//   // Save PDF
//   doc.save(`${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
// };

// export default exportToPDF;

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const cleanText = (text) => {
  if (text === null || text === undefined) return '';
  return String(text)
    .normalize('NFKC')                // normalize Unicode
    .replace(/[^\d₦N.,\-\w\s]/g, '')  // remove bad chars
    .replace(/\s+/g, ' ')             // collapse spaces
    .trim();
};

const exportToPDF = (data, title, columns, rows) => {
  const doc = new jsPDF({
    orientation: 'p',
    unit: 'pt',
    format: 'a4',
    compress: true,
    putOnlyUsedFonts: true,
    encryption: { userPermissions: ['print'] },
  });

  // Use a built-in font that handles Unicode best
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(18);
  doc.text(title, 40, 50, { encoding: 'Identity-H' });

  doc.setFontSize(12);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 40, 70, { encoding: 'Identity-H' });

  // Clean each row before adding to table
  const sanitizedRows = rows.map((r) => r.map(cleanText));

  autoTable(doc, {
    head: [columns],
    body: sanitizedRows,
    startY: 90,
    theme: 'grid',
    headStyles: {
      fillColor: [59, 130, 246],
      textColor: 255,
      fontStyle: 'bold',
    },
    styles: {
      font: 'helvetica',
      fontSize: 10,
      textColor: [0, 0, 0],
      encoding: 'Identity-H',
    },
    alternateRowStyles: {
      fillColor: [243, 244, 246],
    },
  });

  doc.save(`${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

export default exportToPDF;

